import React from "react";
import { AlertTriangle, X } from "lucide-react";

/**
 * Professional confirmation dialog modal
 * Used for destructive actions
 */
const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  type = "danger", // 'danger' or 'warning'
}) => {
  if (!isOpen) return null;

  const confirmButtonClass =
    type === "danger"
      ? "bg-red-600 hover:bg-red-700 focus:ring-red-500"
      : "bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="
          bg-white rounded-xl shadow-2xl
          max-w-md w-full p-6
          animate-in zoom-in-95 fade-in duration-200
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>

          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Close dialog"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Message */}
        <p className="text-sm text-gray-600 mb-6 leading-relaxed">{message}</p>

        {/* Actions */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="
              px-4 py-2 text-sm font-medium
              text-gray-700 bg-white border border-gray-300
              rounded-lg hover:bg-gray-50
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2
            "
          >
            {cancelLabel}
          </button>

          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`
              px-4 py-2 text-sm font-medium
              text-white rounded-lg
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-offset-2
              ${confirmButtonClass}
            `}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;


